import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "h20" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "title mc",
  style: {}
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "fw600 fs24 centered",
    style: {"color":"#696969"}
  }, "企業URL")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = {
  class: "",
  style: {}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "fs14 fw600 mt10" }, [
  /*#__PURE__*/_createTextVNode(" 企業で統一したURLを設定しましょう！"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs12 fw400" }, "あとでアカウント設定から変更可能です。半角英数字（3文字以上）が使用可能です。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs13 text-warning" }, "※ すべての公開ページのURLが変更されます。")
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  class: "posAb w100 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "fs14 whiteColor fw600",
  style: {"padding-top":"15px"}
}, "作成", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "with_white_bg dgrey fs16 pointer centered w100 lgreyBg disabled",
  style: {"line-height":"50px","height":"50px"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw400" }, "未入力です", -1)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "InputGroupNamespaceModal",
    "content-class": "rad10 with_white_bg shadowContent modalSmall noscroll ",
    onBeforeClose: _ctx.fadeOutModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "pad15",
        style: _normalizeStyle(`width:400px;height:${_ctx.contentHeight}px`)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "fr pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, null, 8, _hoisted_2)
        ]),
        _hoisted_3,
        _createElementVNode("div", {
          class: "ofs centered",
          style: _normalizeStyle(`height: ${_ctx.contentHeight}px;overscroll-behavior: contain;`)
        }, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_MdTextfieldTag, {
              fieldStyle: "min-width:280px;max-width:100%;",
              style: {"height":"56px","min-width":"280px","max-width":"100%"},
              class: "fl fs16",
              type: `AstagName`,
              placeholder: `waaq`,
              value: _ctx.namespace,
              onInputValue: _ctx.inputNamespace,
              onBlur: _ctx.checkName,
              errMessage: _ctx.validName ? null : `入力してください。`,
              required: ""
            }, null, 8, ["value", "onInputValue", "onBlur", "errMessage"])
          ]),
          (_ctx.Util.isPresent(_ctx.ngReasons))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ngReasons, (ngMessage) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: ngMessage,
                    class: "alertRed fw600 fs11"
                  }, _toDisplayString(ngMessage), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 4)
      ], 4),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          (_ctx.validName)
            ? (_openBlock(), _createElementBlock("section", {
                key: 0,
                id: "roomCloseButton",
                class: "w100 skyblueBg fs16 pointer centered",
                style: {"line-height":"50px","height":"50px"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createNamespace && _ctx.createNamespace(...args)))
              }, _hoisted_13))
            : (_openBlock(), _createElementBlock("section", _hoisted_14, _hoisted_16))
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeClose"]))
}